{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Lade Editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot Name",
        "PLACEHOLDER": "Benenne den Bot.",
        "ERROR": "Bot Name ist erforderlich."
      },
      "DESCRIPTION": {
        "LABEL": "Bot Beschreibung",
        "PLACEHOLDER": "Was macht dieser Bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Bitte geben Sie Ihre CSML Bot-Konfiguration oben ein.",
        "API_ERROR": "Deine CSML-Konfiguration ist ungültig, bitte korrigiere sie und versuche es erneut."
      },
      "SUBMIT": "Validieren und speichern"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Agenten-Bot auswählen",
      "DESC": "Weise deinem Posteingang einen Agent Bot zu. Er kann die ersten Konversationen bearbeiten und sie bei Bedarf an einen echten Agenten übertragen.",
      "SUBMIT": "Aktualisieren",
      "DISCONNECT": "Bot-Verbindung trennen",
      "SUCCESS_MESSAGE": "Agenten-Bot erfolgreich aktualisiert.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Agent-Bot erfolgreich getrennt.",
      "ERROR_MESSAGE": "Der Agent Bot konnte nicht aktualisiert werden, bitte versuche es später erneut.",
      "DISCONNECTED_ERROR_MESSAGE": "Der Agent Bot konnte nicht entfernt werden, bitte versuchen Sie es später erneut.",
      "SELECT_PLACEHOLDER": "Bot auswählen",
      "OPTION": "{name} ({description})",
      "COUNTRY_BOTS": {
        "TITLE": "Bots nach Land",
        "DESC": "Dieser Posteingang bedient mehrere Länder. Eine Konversation geht an den Bot ihres Landes: nach dem Kaufland-Shop, dem Marktplatz der Allegro-Bestellung oder andernfalls nach der Sprache, in der der Kunde schreibt. Alle anderen Konversationen gehen an den oben gewählten Standard-Bot.",
        "COUNTRY": "Land auswählen",
        "BOT": "Bot auswählen",
        "ADD": "Bot für ein Land hinzufügen",
        "REMOVE": "Entfernen",
        "DEFAULT_REQUIRED": "Wähle zuerst einen Standard-Bot. Der Bot eines Landes ersetzt ihn nur für dieses Land.",
        "DISCONNECT_ALL": "Alle Bot-Verbindungen trennen"
      }
    },
    "ADD": {
      "TITLE": "Neuen Bot konfigurieren",
      "CANCEL_BUTTON_TEXT": "Stornieren",
      "API": {
        "SUCCESS_MESSAGE": "Bot erfolgreich hinzugefügt.",
        "ERROR_MESSAGE": "Bot konnte nicht hinzugefügt werden, bitte versuchen Sie es später erneut."
      }
    },
    "LIST": {
      "404": "Keine Bots gefunden. Du kannst einen Bot erstellen, indem du auf den 'Neuen Bot konfigurieren' Knopf klickst ↗",
      "LOADING": "Bots werden geladen...",
      "TYPE": "Bot-Typ",
      "TABLE_HEADER": {
        "DETAILS": "Bot-Details",
        "URL": "Webhook-URL"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Löschen",
      "TITLE": "Bot löschen",
      "SUBMIT": "Löschen",
      "CANCEL_BUTTON_TEXT": "Stornieren",
      "DESCRIPTION": "Sind Sie sicher, dass Sie diesen Bot löschen wollen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "API": {
        "SUCCESS_MESSAGE": "Bot erfolgreich gelöscht.",
        "ERROR_MESSAGE": "Der Bot konnte nicht gelöscht werden, bitte versuche es später erneut."
      },
      "CONFIRM": {
        "TITLE": "Löschen bestätigen",
        "MESSAGE": "Sind Sie sicher, dass Sie {name} löschen möchten?",
        "YES": "Ja, löschen",
        "NO": "Nein, beibehalten"
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Bearbeiten",
      "LOADING": "Bots werden geladen...",
      "TITLE": "Bot bearbeiten",
      "CANCEL_BUTTON_TEXT": "Stornieren",
      "API": {
        "SUCCESS_MESSAGE": "Bot erfolgreich aktualisiert.",
        "ERROR_MESSAGE": "Der Bot konnte nicht aktualisiert werden, bitte versuche es später erneut."
      }
    },
    "TYPES": {
      "WEBHOOK": "Webhook Bot",
      "CSML": "CSML Bot"
    },
    "GLOBAL_BOT": "System-Bot",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot-Avatar erfolgreich gelöscht",
      "ERROR_DELETE": "Fehler beim Löschen des Bot-Avatars, bitte versuchen Sie es erneut"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot-Avatar"
      },
      "NAME": {
        "LABEL": "Bot-Name",
        "PLACEHOLDER": "Bot-Namen eingeben",
        "REQUIRED": "Bot-Name ist erforderlich"
      },
      "DESCRIPTION": {
        "LABEL": "Beschreibung",
        "PLACEHOLDER": "Was macht dieser Bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook-URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook-URL ist erforderlich"
      },
      "ERRORS": {
        "NAME": "Bot-Name ist erforderlich",
        "URL": "Webhook-URL ist erforderlich",
        "VALID_URL": "Bitte geben Sie eine gültige URL ein, die mit http:// oder https:// beginnt"
      },
      "CANCEL": "Abbrechen",
      "CREATE": "Bot erstellen",
      "UPDATE": "Bot aktualisieren"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Konfigurieren Sie einen Webhook-Bot, um ihn in Ihre eigenen Dienste zu integrieren. Der Bot empfängt und verarbeitet Ereignisse aus Unterhaltungen und kann darauf antworten."
    }
  }
}
